import styled from '@emotion/styled';
import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import React from 'react';

export interface ITitlePropsProps extends TitleProps {}

const Title: React.FC<ITitlePropsProps> = ({ ...props }) => {
  return <Typography.Title {...props} />;
};

export default styled(Title)``;
